var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 102,
    viewBox: "0 0 77 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4680_60600)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.7852,
    y1: 78.6607,
    x2: 52.2852,
    y2: 78.6607,
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.7852,
    y1: 44.2297,
    x2: 52.2852,
    y2: 44.2297,
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5078,
    y: 37.1934,
    width: 25.1471,
    height: 48.7072,
    fill: "#E4E4E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.625,
    y: 35.174,
    width: 6.54412,
    height: 15.7956,
    fill: "#2D2D2D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 36.7735L20.8959 34.674L24.2489 36.7735",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 39.2928L20.8959 37.1934L24.2489 39.2928",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 41.8122L20.8959 39.7127L24.2489 41.8122",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 44.3315L20.8959 42.232L24.2489 44.3315",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 46.8508L20.8959 44.7514L24.2489 46.8508",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 49.3702L20.8959 47.2707L24.2489 49.3702",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 51.8895L20.8959 49.7901L24.2489 51.8895",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9922,
    y: 35.174,
    width: 6.54412,
    height: 15.7956,
    fill: "#2D2D2D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 36.7735L55.2631 34.674L58.616 36.7735",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 39.2928L55.2631 37.1934L58.616 39.2928",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 41.8122L55.2631 39.7127L58.616 41.8122",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 44.3315L55.2631 42.232L58.616 44.3315",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 46.8508L55.2631 44.7514L58.616 46.8508",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 49.3702L55.2631 47.2707L58.616 49.3702",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 51.8895L55.2631 49.7901L58.616 51.8895",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.625,
    y: 71.2845,
    width: 6.54412,
    height: 15.7956,
    fill: "#2D2D2D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 72.884L20.8959 70.7845L24.2489 72.884",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 75.4033L20.8959 73.3039L24.2489 75.4033",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 77.9227L20.8959 75.8232L24.2489 77.9227",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 80.442L20.8959 78.3425L24.2489 80.442",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 82.9613L20.8959 80.8619L24.2489 82.9613",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 85.4807L20.8959 83.3812L24.2489 85.4807",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 88L20.8959 85.9006L24.2489 88",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9922,
    y: 71.2845,
    width: 6.54412,
    height: 15.7956,
    fill: "#2D2D2D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 72.884L55.2631 70.7845L58.616 72.884",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 75.4033L55.2631 73.3039L58.616 75.4033",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 77.9227L55.2631 75.8232L58.616 77.9227",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 80.442L55.2631 78.3425L58.616 80.442",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 82.9613L55.2631 80.8619L58.616 82.9613",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 85.4807L55.2631 83.3812L58.616 85.4807",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9102 88L55.2631 85.9006L58.616 88",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7684,
    cy: 20.5644,
    rx: 7.12392,
    ry: 7.13703,
    fill: "url(#paint0_linear_4680_60600)"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02521,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 20.7695 14.1411)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.0252,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 20.0586 29.8426)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.957,
    y1: 25.3467,
    x2: 12.9346,
    y2: 25.3467,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.4922,
    y1: 16.7822,
    x2: 26.4698,
    y2: 16.7822,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02762,
    y2: -0.5,
    transform: "matrix(0.258375 0.966045 -0.965807 0.259263 26.5078 23.3844)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02762,
    y2: -0.5,
    transform: "matrix(0.258375 0.966045 -0.965807 0.259264 13.6445 14.8548)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.577,
    cy: 20.5644,
    rx: 7.12392,
    ry: 7.13703,
    fill: "url(#paint1_linear_4680_60600)"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02521,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 38.5781 14.1411)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.0252,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 37.8672 29.8426)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.7656,
    y1: 25.3467,
    x2: 30.7432,
    y2: 25.3467,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.3008,
    y1: 16.7822,
    x2: 44.2784,
    y2: 16.7822,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02762,
    y2: -0.5,
    transform: "matrix(0.258375 0.966045 -0.965807 0.259263 44.3164 23.3844)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02762,
    y2: -0.5,
    transform: "matrix(0.258375 0.966045 -0.965807 0.259263 31.4531 14.8548)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.9755,
    cy: 20.5644,
    rx: 7.12391,
    ry: 7.13703,
    fill: "url(#paint2_linear_4680_60600)"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02521,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 55.9766 14.1411)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.0252,
    y2: -0.5,
    transform: "matrix(0.706456 -0.707757 0.706456 0.707757 55.2656 29.8426)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.1641,
    y1: 25.3467,
    x2: 48.1416,
    y2: 25.3467,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.6992,
    y1: 16.7822,
    x2: 61.6768,
    y2: 16.7822,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02762,
    y2: -0.5,
    transform: "matrix(0.258375 0.966045 -0.965807 0.259263 61.7148 23.3844)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.02761,
    y2: -0.5,
    transform: "matrix(0.258374 0.966045 -0.965806 0.259265 48.8516 14.8548)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4492,
    y: 20.3978,
    width: 46.1029,
    height: 20.9945,
    fill: "url(#paint3_linear_4680_60600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0727 75.7405H38.0796M36.1363 73.8005C36.6499 73.2861 37.3465 72.9971 38.0727 72.9971C38.799 72.9971 39.4955 73.2861 40.0091 73.8005M34.1992 71.8598C34.7079 71.3502 35.3118 70.9459 35.9764 70.6701C36.641 70.3943 37.3533 70.2524 38.0727 70.2524C38.7921 70.2524 39.5044 70.3943 40.169 70.6701C40.8337 70.9459 41.4375 71.3502 41.9462 71.8598",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2617 69.9198C35.4703 66.7046 40.6729 66.7046 43.9021 69.9198",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4680_60600",
    x: -2,
    y: 0.292242,
    width: 81,
    height: 101.132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.796078 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4680_60600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4680_60600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4680_60600",
    x1: 13.6445,
    y1: 20.5644,
    x2: 27.8924,
    y2: 20.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4680_60600",
    x1: 31.4531,
    y1: 20.5644,
    x2: 45.701,
    y2: 20.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4680_60600",
    x1: 48.8516,
    y1: 20.5644,
    x2: 63.0994,
    y2: 20.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4680_60600",
    x1: 41.6194,
    y1: 41.7752,
    x2: 42.5797,
    y2: 21.9791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.cbeb9d45fb7d20d87e3980b0ebc8d111.svg";
export { ForwardRef as ReactComponent };